import { render, staticRenderFns } from "./QuestionForm2.vue?vue&type=template&id=779a6e72&scoped=true"
import script from "./QuestionForm2.vue?vue&type=script&lang=js"
export * from "./QuestionForm2.vue?vue&type=script&lang=js"
import style0 from "./QuestionForm2.vue?vue&type=style&index=0&id=779a6e72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779a6e72",
  null
  
)

export default component.exports